<template>
    <el-dialog
        title="整车异常发车原因"
        width="35%"
        :visible.sync="registerVisible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'abnormalReasonDialog'"
        >
        <div class="reason-header">异常发车原因</div>
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item prop="abnormalDepartReason">
                <el-radio-group v-model="form.abnormalDepartReason" class="reasonType-group" @change="change">
                    <el-radio
                        v-for="item in reasonList"
                        :key="item.value"
                        :label="item.value">
                        {{ item.label }}
                        <el-input
                            v-if="+item.value === 99"
                            v-model="form.abnormalDepartReasonRemark"
                            type="text"
                            :disabled="form.abnormalDepartReason !== '99'"
                            maxlength="50"
                            clearable>
                        </el-input>
                    </el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div class="remark">
            <div>注释：</div>
            <div>1、仅整车可登记</div>
            <div>2、仅“是否在始发地围栏”为“否”时可登记</div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" :loading="btnLoading">确 认</el-button>
            <el-button @click="beforeClose">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { dictWithUrl } from '@/components/lots/api.js';
import { formatDictDataToLabelValue } from './util.js';
import { registerAbnormalDepartReason } from '../../../api/dispatchOrder';
export default {
    name: 'DispatchAbnormalReason',
    props: {
        componentsData: {
            type: [Object, Array]
        },
        registerVisible: {
            type: Boolean,
            default: false
        },
    },
    data () {
        var validateRadio = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('异常发车原因必选'));
            } else if (+value === 99 && !this.form.abnormalDepartReasonRemark) {
                return callback(new Error('必填备注原因,填写限制50个字。'));
            } else {
                callback();
            }
        };
        return {
            btnLoading: false,
            form: {
                abnormalDepartReason: '',
                abnormalDepartReasonRemark: ''
            },
            rules: {
                abnormalDepartReason: [
                    { validator: validateRadio, trigger: ['blur', 'change'] }
                ]
            },
            reasonList: [],
            dictData: {}
        };
    },
    async mounted () {
        await this.getDicData();
        this.reasonList = formatDictDataToLabelValue(this.dictData.ABNORMAL_DEPART_REASON);
    },
    methods: {
        /**
         * @description 获取数据字典
         * 异常发车原因：ABNORMAL_DEPART_REASON
         */
        async getDicData () {
            const dict = await dictWithUrl(
                // eslint-disable-next-line max-len
                'ABNORMAL_DEPART_REASON'
            );
            this.dictData = dict.data;
        },
        /**
         * @description 关闭
         */
        beforeClose () {
            this.$emit('close');
        },
        /**
         * @description 单选框发生改变时触发事件
         */
        change () {
            // 整车异常原因不为其他时，备注输入框清空
            if (+this.form.abnormalDepartReason !== 99) {
                this.form.abnormalDepartReasonRemark = '';
            }
        },
        /**
         * @description 提交
         */
        handleSubmit () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.btnLoading = true;
                    registerAbnormalDepartReason(this.getParams()).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('保存成功');
                            this.beforeClose();
                        }
                    }).finally(() => {
                        this.btnLoading = false;
                    });
                };
            });
        },
        /**
         * @description 组装提交参数
         */
        getParams () {
            let params;
            if (Array.isArray(this.componentsData)) {
                // 是否在始发地围栏为否时，才登记
                const registerData = this.componentsData.filter(item => item.startAddrFenceFlag === 0);
                const dispatchNo = registerData.map(item => item.dispatchNo);
                params = {
                    dispatchNos: dispatchNo,
                    abnormalDepartReason: this.form.abnormalDepartReason,
                    abnormalDepartReasonRemark: this.form.abnormalDepartReasonRemark
                };
            } else {
                params = {
                    dispatchNos: [this.componentsData.dispatchNo],
                    abnormalDepartReason: this.form.abnormalDepartReason,
                    abnormalDepartReasonRemark: this.form.abnormalDepartReasonRemark
                };
            }
            return params;
        }
    }
};
</script>

<style lang="less" scoped>
.abnormalReasonDialog {
    .reason-header {
        font-size: 16px;
        margin-bottom: 10px;
    }
    .el-radio {
        display: block;
        margin-bottom: 10px;
        /deep/.el-radio__input{
            .el-radio__inner {
                border-radius: 0%;
            }
        }
        /deep/ .el-radio__input {
            .el-radio__label {
                font-size: 14px;
            }
        }
    }
    .el-input {
        margin-left: 10px;
    }
    .remark {
        font-size: 13px;
        color: red;
    }
}
/deep/ .el-dialog__body {
        font-size: 16px;
        padding: 16px 50px 0px;
}
/deep/ .el-radio__label {
     font-size: 14px;
}

</style>
